import { useEffect, useState } from "react";

const useCameras = (): MediaDeviceInfo[] => {
  const [cameras, setCameras] = useState<MediaDeviceInfo[]>([]);

  useEffect(() => {
    (async () => {
      try {
        // Request camera permission explicitly first
        await navigator.mediaDevices.getUserMedia({ video: true });
        
        // Then enumerate devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput",
        );
        videoDevices && setCameras(videoDevices);
      } catch (error) {
        console.error("Error accessing camera:", error);
        // Don't set cameras if permission is denied
      }
    })();
  }, []);
  return cameras;
};

export default useCameras;
